import { patientsPDFFolder } from '~/config';
export const getPatientPDFUrl = (fileName) => {
    return `${patientsPDFFolder}${fileName}`;
};
